import React, { useState } from 'react';
import { Modal, Button, message } from 'antd';
import { deleteSMTPConfig } from '../../utils/services/smtpConfigAPI';
import { deleteEFaxUser } from '../../utils/services/efaxAPI';
import { deletePrinter } from '../../utils/services/mailRoomAPI';
import { ModalBody, Container } from './styles';
import { withTranslation } from 'react-i18next';
import {
  DELETE_FAX_PRINTER_SMTP_CONFIGURATIONS_CONFIRMATION_MODAL,
  DELETE_FAX_CONFIGURATIONS_CONFIRMATION_MODAL,
  DELETE_SMTP_CONFIGURATIONS_CONFIRMATION_MODAL,
  DELETE_PRINTER_CONFIGURATIONS_CONFIRMATION_MODAL
} from '../../containers/UserSettingsPage/TranslationValues';

const NAMESPACE = [
  'DELETE_SMTP_CONFIGURATIONS_CONFIRMATION_MODAL',
  'DELETE_FAX_PRINTER_SMTP_CONFIGURATIONS_CONFIRMATION_MODAL',
  'DELETE_FAX_CONFIGURATIONS_CONFIRMATION_MODAL',
  'DELETE_PRINTER_CONFIGURATIONS_CONFIRMATION_MODAL',
];
const DELETE_ADMIN_MODAL = 'DELETE_FAX_PRINTER_SMTP_CONFIGURATIONS_CONFIRMATION_MODAL'
const DELETE_FAX_MODAL = 'DELETE_FAX_CONFIGURATIONS_CONFIRMATION_MODAL'
const DELETE_PRINTER_MODAL = 'DELETE_PRINTER_CONFIGURATIONS_CONFIRMATION_MODAL'
const DELETE_SMTP_MODAL = 'DELETE_SMTP_CONFIGURATIONS_CONFIRMATION_MODAL';
const DeleteSMTPConfigModal = props => {
  const { visible, onCancel, targetUser, isFaxUser, isDeletePrinter, t } = props;
  const [deleting, setDeleting] = useState(false);
  const onDelete = () => {
    const payload = {
      id: targetUser.id,
    };
    deleteAddedSMTP(payload);
  };
  const deleteAddedSMTP = async payload => {
    setDeleting(true);
    let deletionResponse;
    if (isFaxUser) {
      deletionResponse = await deleteEFaxUser(targetUser.id);
    } else if (isDeletePrinter) {
      deletionResponse = await deletePrinter(payload);
    } else {
      deletionResponse = await deleteSMTPConfig(payload);
    }
    setDeleting(false);
    if (deletionResponse && deletionResponse.status) {
      if (deletionResponse.status === 'SMTPServerConfig deleted successfully') {
        onCancel(true);
        message.success(t(`${DELETE_SMTP_MODAL}:${DELETE_SMTP_CONFIGURATIONS_CONFIRMATION_MODAL.DELETE_SMTP_CONFIGURATION_SUCCESS_MESSAGE.key}`,DELETE_SMTP_CONFIGURATIONS_CONFIRMATION_MODAL.DELETE_SMTP_CONFIGURATION_SUCCESS_MESSAGE.value));
      } else if (deletionResponse?.statusCode === 1108) {
        onCancel();
        message.error(t(`${DELETE_SMTP_MODAL}:${DELETE_SMTP_CONFIGURATIONS_CONFIRMATION_MODAL.DELETE_SMTP_CONFIGURATION_FAILURE_MESSAGE.key}`,DELETE_SMTP_CONFIGURATIONS_CONFIRMATION_MODAL.DELETE_SMTP_CONFIGURATION_FAILURE_MESSAGE.value));
      } else if (deletionResponse?.statusCode === 671) {
        onCancel(true);
        message.success(t(`${DELETE_FAX_MODAL}:${DELETE_FAX_CONFIGURATIONS_CONFIRMATION_MODAL.DELETE_FAX_CONFIGURATION_SUCCESS_MESSAGE.key}`,DELETE_FAX_CONFIGURATIONS_CONFIRMATION_MODAL.DELETE_FAX_CONFIGURATION_SUCCESS_MESSAGE.value));
      } else if (deletionResponse?.statusCode === 656) {
        onCancel();
        message.error(t(`${DELETE_FAX_MODAL}:${DELETE_FAX_CONFIGURATIONS_CONFIRMATION_MODAL.DELETE_FAX_CONFIGURATION_ERROR_MESSAGE.key}`,DELETE_FAX_CONFIGURATIONS_CONFIRMATION_MODAL.DELETE_FAX_CONFIGURATION_ERROR_MESSAGE.value));
      } else if (deletionResponse?.statusCode === 1516) {
        onCancel(true);
        message.success(t(`${DELETE_PRINTER_MODAL}:${DELETE_PRINTER_CONFIGURATIONS_CONFIRMATION_MODAL.DELETE_PRINTER_CONFIGURATION_SUCCESS_MESSAGE.key}`,DELETE_PRINTER_CONFIGURATIONS_CONFIRMATION_MODAL.DELETE_PRINTER_CONFIGURATION_SUCCESS_MESSAGE.value));
      } else if (deletionResponse?.statusCode === 1517) {
        onCancel();
        message.error(t(`${DELETE_PRINTER_MODAL}:${DELETE_PRINTER_CONFIGURATIONS_CONFIRMATION_MODAL.DELETE_PRINTER_CONFIGURATION_FAILURE_MESSAGE.key}`,DELETE_PRINTER_CONFIGURATIONS_CONFIRMATION_MODAL.DELETE_PRINTER_CONFIGURATION_FAILURE_MESSAGE.value));
      } else {
        onCancel();
        if (deletionResponse && deletionResponse.errors) {
          if (deletionResponse?.errors[0]?.description) {
            // message.error(deletionResponse?.errors[0]?.description);
          } else {
            message.error(deletionResponse.status);
          }
        }
      }
    }
  };

  return (
    <Container onKeyDown={e => e.stopPropagation()}>
      <Modal
        title={
          isFaxUser
            ? t(`${DELETE_FAX_MODAL}:${DELETE_FAX_CONFIGURATIONS_CONFIRMATION_MODAL.DELETE_FAX_CONFIGURATION_MODAL_TITLE.key}`,DELETE_FAX_CONFIGURATIONS_CONFIRMATION_MODAL.DELETE_FAX_CONFIGURATION_MODAL_TITLE.value)
            : isDeletePrinter
            ? t(`${DELETE_PRINTER_MODAL}:${DELETE_PRINTER_CONFIGURATIONS_CONFIRMATION_MODAL.DELETE_PRINTER_CONFIGURATION_MODAL_TITLE.key}`,DELETE_PRINTER_CONFIGURATIONS_CONFIRMATION_MODAL.DELETE_PRINTER_CONFIGURATION_MODAL_TITLE.value)
            : t(DELETE_SMTP_CONFIGURATIONS_CONFIRMATION_MODAL.DELETE_SMTP_CONFIGURATION_MODAL_TITLE.key,DELETE_SMTP_CONFIGURATIONS_CONFIRMATION_MODAL.DELETE_SMTP_CONFIGURATION_MODAL_TITLE.value)
        }
        centered
        visible={visible}
        width="625px"
        onCancel={() => onCancel(false)}
        footer={[
          <Button key="back" onClick={() => onCancel(false)}>
            {t(`${DELETE_ADMIN_MODAL}:${DELETE_FAX_PRINTER_SMTP_CONFIGURATIONS_CONFIRMATION_MODAL.CANCEL_DELETE_CONFIGURATIONS_BUTTON.key}`,DELETE_FAX_PRINTER_SMTP_CONFIGURATIONS_CONFIRMATION_MODAL.CANCEL_DELETE_CONFIGURATIONS_BUTTON.value)}
          </Button>,
          <Button key="submit" type="primary" loading={deleting} onClick={onDelete}>
            {deleting ? t(`${DELETE_ADMIN_MODAL}:${DELETE_FAX_PRINTER_SMTP_CONFIGURATIONS_CONFIRMATION_MODAL.DELETE_ADMIN_CONFIGURATIONS_CONFIRMATION_MODAL_DELETING_BUTTON.key}`,DELETE_FAX_PRINTER_SMTP_CONFIGURATIONS_CONFIRMATION_MODAL.DELETE_ADMIN_CONFIGURATIONS_CONFIRMATION_MODAL_DELETING_BUTTON.value) : t(`${DELETE_ADMIN_MODAL}:${DELETE_FAX_PRINTER_SMTP_CONFIGURATIONS_CONFIRMATION_MODAL.DELETE_ADMIN_CONFIGURATIONS_CONFIRMATION_MODAL_DELETE_BUTTON.key}`,DELETE_FAX_PRINTER_SMTP_CONFIGURATIONS_CONFIRMATION_MODAL.DELETE_ADMIN_CONFIGURATIONS_CONFIRMATION_MODAL_DELETE_BUTTON.value)}
          </Button>,
        ]}
        className="warning-modal"
      >
        <ModalBody>
          <div className="warning-text">
            <span>
              {isFaxUser
                ? t(`${DELETE_FAX_MODAL}:${DELETE_FAX_CONFIGURATIONS_CONFIRMATION_MODAL.SURE_TO_DELETE_FAX_CONFIRMATION_MESSAGE.key}`,DELETE_FAX_CONFIGURATIONS_CONFIRMATION_MODAL.SURE_TO_DELETE_FAX_CONFIRMATION_MESSAGE.value)
                : isDeletePrinter
                ? t(`${DELETE_PRINTER_MODAL}:${DELETE_PRINTER_CONFIGURATIONS_CONFIRMATION_MODAL.SURE_TO_DELETE_PRINTER_CONFIRMATION_TITLE.key}`,DELETE_PRINTER_CONFIGURATIONS_CONFIRMATION_MODAL.SURE_TO_DELETE_PRINTER_CONFIRMATION_TITLE.value)
                : t(DELETE_SMTP_CONFIGURATIONS_CONFIRMATION_MODAL.SURE_TO_DELETE_SMTP_CONFIRMATION_TITLE.key,DELETE_SMTP_CONFIGURATIONS_CONFIRMATION_MODAL.SURE_TO_DELETE_SMTP_CONFIRMATION_TITLE.value)}
                {targetUser && <span className="text-highlighter">{isFaxUser ? targetUser.configName : targetUser.userName}</span>}
                ?
            </span> 
          </div>
        </ModalBody>
      </Modal>
    </Container>
  );
};
export default withTranslation(NAMESPACE)(DeleteSMTPConfigModal);
